import { i18n } from 'src/i18n';
import ResourceService from 'src/modules/resource/resourceService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';

const prefix = 'RESOURCE_FORM';

const resourceFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: resourceFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await ResourceService.find(id);
      }

      dispatch({
        type: resourceFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: resourceFormActions.INIT_ERROR,
      });

      getHistory().push('/resource');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: resourceFormActions.CREATE_STARTED,
      });

      await ResourceService.create(values);

      dispatch({
        type: resourceFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.resource.create.success'),
      );

      getHistory().push('/resource');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: resourceFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, _getState) => {
    try {
      dispatch({
        type: resourceFormActions.UPDATE_STARTED,
      });

      await ResourceService.update(id, values);

      dispatch({
        type: resourceFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.resource.update.success'),
      );

      // getHistory().push('/resource');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: resourceFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default resourceFormActions;
